import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const AsyncHome = () => import("../views/Home.vue");

const routes = [
  {
    path: "/",
    name: "Home",
    component: AsyncHome,
    children: [
      {
        path: "/",
        component: () => import("../components/MainPageComponents.vue"),
      },
      {
        path: "kontakt",
        component: () => import("../components/Contact.vue"),
      },
      {
        path: "regulamin",
        component: () => import("../components/Rules.vue"),
      },
      {
        path: "pytania-i-odpowiedzi",
        component: () => import("../components/QA.vue"),
      },
      {
        path: "pytania-i-odpowiedzi/:id",
        component: () => import("../components/OAChildren.vue"),
      },
      {
        path: "o-pszczolach",
        component: () => import("../components/AboutBees/AboutBees.vue"),
      },
      {
        path: "o-pszczolach/:id",
        component: () => import("../components/AboutBees/AboutBeesSingle.vue"),
      },
      {
        path: "prywatnosc",
        component: () => import("../components/Privacy.vue"),
      },
      {
        path: "/json",
        name: "json",
        component: () => import("../views/Json.vue"),
      },
    ],
  },
  {
    path: "/thankyou_single",
    name: "Podziekowanie za pojedyńczą adopcję",
    component: () => import("../views/ThanksSingle.vue"),
  },
  {
    path: "/thankyou_single_plus",
    name: "Podziekowanie za pojedyńczą adopcję powyżej 25 pszczół",
    component: () => import("../views/ThanksSinglePlus.vue"),
  },
  {
    path: "/thankyou_regular",
    name: "Podziekowanie za regularną adopcję",
    component: () => import("../views/ThanksRegular.vue"),
  },
  {
    path: "/error",
    name: "Error",
    component: () => import("../views/Error.vue"),
  },
  {
    path: "/pending",
    name: "Pending",
    component: () => import("../views/Pending.vue"),
  },

  {
    path: "/404",
    component: () => import("../views/PageNotFound.vue"),
  },
  {
    path: "*",
    component: () => import("../views/PageNotFound.vue"),
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    }
  },
});

export default router;
